import { createMachine } from 'xstate';

import shared from 'common/bento/shared';
import { BentoModuleDoneStatus } from 'common/bento/types/BentoModule';
import { AnyMachineEvent } from 'features/Bento/types/Abstract';

import actions from './actions';
import guards from './guards';
import model, { Context } from './model';
import services from './services';
import { State } from './state';

const machine = createMachine<Context, AnyMachineEvent>(
  {
    context: model.initialContext,

    id: 'proof-of-funds',

    initial: State.INIT,

    on: {
      '*': {
        actions: shared.actions.unhandled(),
      },
    },

    states: {
      [State.INIT]: {
        always: [
          { cond: 'isDocumentUploaded', target: State.REVIEW },
          {
            target: State.CHOOSE_DOCUMENT_TYPE,
          },
        ],
      },

      [State.CHOOSE_DOCUMENT_TYPE]: {
        entry: shared.actions.trackView(),

        on: {
          PREV: State.ABORT,
          SELECT_DOCUMENT_TYPE: {
            actions: 'assignDocumentType',
            target: State.UPLOAD,
          },
        },
      },

      [State.UPLOAD]: {
        entry: shared.actions.trackView(),

        on: {
          PREV: State.CHOOSE_DOCUMENT_TYPE,
          SUBMIT_DOCUMENT_FILE: {
            actions: 'assignDocumentFile',
            target: State.CHECK,
          },
        },
      },

      [State.CHECK]: {
        entry: shared.actions.trackView(),

        on: {
          NEXT: {
            actions: shared.actions.track({
              name: 'Proof_Of_Funds_Succeeded',
            }),
            target: State.SEND,
          },
          PREV: {
            actions: shared.actions.track({
              name: 'Proof_Of_Funds_Failed',
            }),
            target: State.UPLOAD,
          },
        },
      },

      [State.SEND]: {
        invoke: {
          onDone: {
            target: State.REVIEW,
          },
          onError: {
            actions: shared.actions.error(),
            target: State.UPLOAD,
          },
          src: 'sendDocument',
        },
      },

      [State.REVIEW]: {
        entry: shared.actions.trackView(),

        on: {
          DELETE_DOCUMENT: State.DELETE,
          NEXT: State.DONE,
          PREV: State.ABORT,
        },
      },

      [State.DELETE]: {
        invoke: {
          onDone: {
            target: State.CHOOSE_DOCUMENT_TYPE,
          },
          onError: {
            actions: shared.actions.error(),
            target: State.INIT,
          },
          src: 'deleteDocument',
        },
      },

      [State.ABORT]: {
        data: {
          status: BentoModuleDoneStatus.ABORT,
        },
        type: 'final',
      },

      [State.DONE]: {
        data: {
          status: BentoModuleDoneStatus.DONE,
        },
        type: 'final',
      },
    },
  },

  {
    actions,
    guards,
    services,
  },
);

export default machine;
